/** Old shared categories were written in English, including the Portuguese catalog. */
export const sharedCopy: Record<string, Record<string, string>> = {
  'pt-BR': {
    'Unsaved Changes': 'Alterações não salvas',
    'You have unsaved changes. Do you really want to leave?': 'Você tem alterações não salvas. Deseja realmente sair?',
    'Leave Anyway': 'Sair mesmo assim',
    'Embed code copied': 'Código de incorporação copiado',
    'Embed Video': 'Incorporar vídeo',
    'Embed video description': 'Incorpore este vídeo na sua página.',
    'iFrame embed description': 'Use um iframe para incorporar o vídeo na sua página.',
    'JavaScript embed description': 'Use o código JavaScript para incorporar o vídeo na sua página.',
    'Copy embed code': 'Copiar código de incorporação',
  },
  en: {
    'Melhoria': 'Improvement',
    'Correção': 'Fix',
    'Refatoração': 'Refactoring',
    'Unsaved Changes': 'Unsaved changes',
    'You have unsaved changes. Do you really want to leave?': 'You have unsaved changes. Do you really want to leave?',
    'Leave Anyway': 'Leave anyway',
    'Embed code copied': 'Embed code copied',
    'Embed Video': 'Embed video',
    'Embed video description': 'Embed this video on your page.',
    'iFrame embed description': 'Use an iframe to embed the video on your page.',
    'JavaScript embed description': 'Use the JavaScript code to embed the video on your page.',
    'Copy embed code': 'Copy embed code',
  },
  es: {
    'Melhoria': 'Mejora',
    'Correção': 'Corrección',
    'Refatoração': 'Refactorización',
    'Unsaved Changes': 'Cambios sin guardar',
    'You have unsaved changes. Do you really want to leave?': 'Tienes cambios sin guardar. ¿Seguro que quieres salir?',
    'Leave Anyway': 'Salir de todos modos',
    'Embed code copied': 'Código de inserción copiado',
    'Embed Video': 'Insertar video',
    'Embed video description': 'Inserta este video en tu página.',
    'iFrame embed description': 'Usa un iframe para insertar el video en tu página.',
    'JavaScript embed description': 'Usa el código JavaScript para insertar el video en tu página.',
    'Copy embed code': 'Copiar código de inserción',
  },
  fr: {
    'Melhoria': 'Amélioration',
    'Correção': 'Correction',
    'Refatoração': 'Refactorisation',
    'Unsaved Changes': 'Modifications non enregistrées',
    'You have unsaved changes. Do you really want to leave?': 'Vous avez des modifications non enregistrées. Voulez-vous vraiment quitter ?',
    'Leave Anyway': 'Quitter quand même',
    'Embed code copied': 'Code d’intégration copié',
    'Embed Video': 'Intégrer la vidéo',
    'Embed video description': 'Intégrez cette vidéo sur votre page.',
    'iFrame embed description': 'Utilisez un iframe pour intégrer la vidéo sur votre page.',
    'JavaScript embed description': 'Utilisez le code JavaScript pour intégrer la vidéo sur votre page.',
    'Copy embed code': 'Copier le code d’intégration',
  },
};
